import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";
import "./Catalog.styles.css";


const Catalog = () => {

    const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [catalogs, setCatalogs] = useState(false);
    const [selectedCatalog, setSelectedCatalog] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);

    async function getCatalogs () {
      // userDetails.arnum="ARM-90195171";
        setCatalogs(false);
        await Axios.get(`/corporate/catalog/${userDetails.arnum}`)
        .then(async (catalogs) => {
            if (catalogs.status == 200 && catalogs.data?.data?.catalogs) {
              setCatalogs(catalogs.data.data.catalogs);
            }
        })
    }

    async function addNewCatalog (values) {
        await Axios.post(`/corporate/catalog/${userDetails.arnum}`,{
          "catalog": {
            "catalogname": values.catalogname
          }
        })
        .then(async (catalogs) => {
          getCatalogs(userDetails.refnum);
          toast.success('New catalog added successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setEmShow(false);
        })
    }

    async function deleteCatalog () {
      if(selectedCatalog){
        await Axios.delete(`/corporate/catalog/${userDetails.arnum}/${selectedCatalog}`)
        .then(async (catalogs) => {
          getCatalogs(userDetails.refnum);
          toast.success('Catalog deleted successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setDmShow(false);
        })
      }
    }

    useEffect(() => {
        setLogedIn(AuthVerify.isUserLogedIn());
    }, []);

    useEffect(() => {
        if(logedIn)setUserDetails(AuthVerify.getUser());
    }, [logedIn]);

    useEffect(() => {
        if(userDetails)getCatalogs(userDetails.refnum);
    }, [userDetails]);

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Catalog</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus</p> */}
        </div>
        <div className="dashboard">
          <hr/>
          <div className="box-account" style={{ display: "grid" }}>
          <div className="toolbar">
              <div className="row">
                <div className="col-md-3 col-sm-3" style={{display: "flex"}}>
                  <h2 style={{fontSize: "16px" , letterSpacing: "1px", marginTop: "0",textTransform: "uppercase", marginBottom: "auto", fontWeight: "700"}}>Your Catalog</h2>
                </div>
                {AuthVerify.getPermissions("Catalog")?.addnew &&
                <div className="col-sm-3 text-right" style={{float:"right"}}>
                  <a href="#" onClick={()=>setEmShow(true)}>+ Add New Catalog</a>
                </div>}
              </div>
            </div>
            <div className="header-nav-dropdown-wrapper header-nav-dropdown-wrapper-1">
              {catalogs ? catalogs.map((item,i)=>{
                return (
                  <div className="jtv-custom-box" style={{ width: "25%" }} key={i}>
                    <h5 className="heading">
                      <i
                        className="fa fa-clipboard"
                        style={{
                          fontSize: "20px",
                          padding: "0",
                          marginTop: "20px",
                          border: "0",
                          background: "transparent",
                        }}
                      ></i>{" "}
                      {item.catalogname}
                    </h5>
                    <small style={{marginTop:"15px"}}>
                    {AuthVerify.getPermissions("Catalog")?.view && <Link to={`/catalog-details?catalognum=${item.catalognum}`}>View</Link>} {" "} 
                    {AuthVerify.getPermissions("Catalog")?.edit && <Link to={`/catalog-details?catalognum=${item.catalognum}`}>Edit</Link>} {" "} 
                    {AuthVerify.getPermissions("Catalog")?.delete && <Link to="#" onClick={()=>{setSelectedCatalog(item.catalognum); setDmShow(true);}} style={{color:"red"}}>Delete</Link>}<br/>
                    </small>
                    {/* <small style="color: #3c763d;">Active</small>  */}
                    <p></p>
                  </div>
                );
              }):
              <Col sm={12} style={{textAlign:"center"}}>No Catalog Found !</Col>
              }
              {/* <div className="jtv-custom-box" style={{ width: "20%" }}>
                <h5 className="heading">
                  <i
                    className="fa fa-clipboard"
                    style={{
                      fontSize: "20px",
                      padding: "0",
                      marginTop: "20px",
                      border: "0",
                      background: "transparent",
                    }}
                  ></i>{" "}
                  Catalog 1
                </h5>
                <small style={{marginTop:"15px"}}>
                <Link to="/shopping-cart">Edit</Link> | <Link to="/shopping-cart" style={{color:"red"}}>Delete</Link><br/>
                </small>
                <p></p>
              </div>
              <div
                className="jtv-custom-box"
                style={{ width: "20%", border: "3px #5aa0dd solid" }}
              >
                <h5 className="heading">
                  <i
                    className="fa fa-clipboard"
                    style={{
                      fontSize: "20px",
                      padding: "0",
                      marginTop: "20px",
                      border: "0",
                      background: "transparent",
                    }}
                  ></i>{" "}
                  Catalog 2
                </h5>
                <small style={{marginTop:"15px"}}>
                <Link to="/shopping-cart">Edit</Link> | <Link to="/shopping-cart" style={{color:"red"}}>Delete</Link><br/>
                </small>
                <p></p>
              </div> */}
            </div>
          </div>
          <br />
        </div>
      </div>

      <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
        <button
              className="button btn-primary"
              title="Proceed to Checkout"
              type="button"
              onClick={()=>deleteCatalog()}
              style={{
                marginRight: "10px",
                padding: "10px"
              }}
              >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={()=>setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setEmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Create New Catalog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Formik
          initialValues={{catalogname:''}}
          validationSchema={Yup.object().shape({
            catalogname: Yup.string().min(2).required("Catalog name is required"),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            addNewCatalog(values);
          }}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              errors, touched
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="box-border">
                  <div className="form-list">
                      
                      <Row>
                        <Col xl={12} sm={12}>
                          <Row>
                            <Col xl={12} sm={12}>
                              <InputField
                                Name="catalogname"
                                id="catalogname"
                                Labels="Catalog Name"
                                Type="text"
                                value={values.catalogname}
                                onChange={e=>{handleChange(e);}}
                                className={(errors.catalogname && touched.catalogname) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                            {/* <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr2"
                                  id="addr2"
                                  Labels="Address 2"
                                  Type="text"
                                  value={values.addr2}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr2}
                                  className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                                />
                              </Col> */}
                          </Row>
                        </Col>
                        
                      </Row>
                  </div>
                </div>
                <Row>
                <div className="cart_navigation">
                  <button
                    className="button btn-proceed-checkout btn-danger"
                    title="Proceed to Checkout"
                    type="button"
                    onClick={() => setEmShow(false)}
                    style={{
                      marginRight: "10px",
                      padding: "10px"
                    }}
                  >
                    <span>Close</span>
                  </button>

              
                    <button
                      className="button btn-proceed-checkout"
                      title="Proceed to Checkout"
                      type="submit"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                    >
                      <span>Create</span>
                    </button>
                </div>
                
                </Row>
              </Form>
            );
          }}
        </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Catalog;
